<template>
  <v-list-item @click.stop.prevent="$evt => copyToClipboard($evt, item.url)">
    <v-list-item-icon>
      <v-icon>mdi-file-multiple-outline</v-icon>
    </v-list-item-icon>

    <v-list-item-content v-text="$t('components.share.clipboard.action')" />
  </v-list-item>
</template>

<script>

async function textToClipboard(text) {
  if (typeof navigator.clipboard === 'function') {
    try {
      const result = await navigator.clipboard.writeText(text);
      return result;
    } catch (ex) {
      throw new Error('error sending text to clipboard', ex);
    }
  }
  const textarea = document.createElement('textarea');

  // avoid scrolling to bottom
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.position = 'fixed';
  textarea.textContent = text;
  textarea.value = text;

  document.body.appendChild(textarea);
  textarea.select();
  textarea.focus();

  try {
    const copyResult = document.execCommand('copy');
    if (!copyResult) {
      throw new Error('cannot send text to clipboard (used fallback textarea mode)');
    }
    return copyResult;
  } catch (ex) {
    console.error('error sending text to clipboard', ex);
    throw ex;
  } finally {
    document.body.removeChild(textarea);
  }
}

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async copyToClipboard(evt, text) {
      evt.preventDefault();
      try {
        await textToClipboard(text);
        this.$emit('input', {
          snackbar: this.$t('components.share.clipboard.textCopied'),
        });
        this.$root.$emit('finishShare');
      } catch (ex) {
        console.error('error copying text', ex);
        this.$root.$emit('finishShare');
        this.$emit('input');
      }
    },
  },
};
</script>
